import { useCallback } from "react";
import { MaritalStatus, User, WorkingPermit } from "../__generated__/graphql";

export const getWorkerProfileIsComplete = (user?: User | null) => {
    const maritalStatus = user?.workerProfile?.maritalStatus;

    const avsNumber = user?.workerProfile?.avsNumber;

    const children = user?.workerProfile?.children || [];

    const bankAccount = user?.workerProfile?.bankAccount;

    const workPermit = user?.workPermit;

    const hasChildren = user?.workerProfile?.hasChildren;

    const partner = user?.workerProfile?.partner;

    const isMarried = maritalStatus === MaritalStatus.Married;

    const isPartnerAndChildrenDataRequired =
        workPermit &&
        [WorkingPermit.PermitB, WorkingPermit.PermitL, WorkingPermit.PermitS].includes(workPermit);

    const isFiscalAttestationRequired = workPermit === WorkingPermit.PermitG;

    const hasFiscalAttestation = user?.workerProfile?.hasFiscalAttestation;

    const email = !user?.clientProfiles?.some((v) => v.businessEmail === user.email)
        ? user?.email
        : user.clientProfiles.find((v) => v.isPrivateClient)?.businessEmail;

    const address = user?.address;

    const nationality = user?.nationality;

    const isForeignerWithoutPermit = nationality !== "CH" && !workPermit;

    const isValid =
        !!maritalStatus &&
        (isForeignerWithoutPermit || (!isForeignerWithoutPermit && !!avsNumber)) &&
        !!bankAccount &&
        !!(
            (isPartnerAndChildrenDataRequired && (partner || !isMarried) && hasChildren !== null) ||
            !isPartnerAndChildrenDataRequired
        ) &&
        !!(
            (isFiscalAttestationRequired && hasFiscalAttestation !== null) ||
            !isFiscalAttestationRequired
        ) &&
        !!email &&
        !!address;

    return {
        isValid,
        maritalStatus,
        bankAccount,
        children,
        hasChildren,
        workPermit,
        isPartnerAndChildrenDataRequired,
        isFiscalAttestationRequired,
        hasFiscalAttestation,
        email,
        address,
        avsNumber,
    };
};

export const useGetIsWorkerProfileComplete = () => {
    return useCallback(getWorkerProfileIsComplete, []);
};
